module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "music-page"
  }, [_c('p', [_c('iframe', {
    attrs: {
      "src": "https://www.youtube.com/embed/ExgpKGmcjDo?rel=0&showinfo=0;start=2",
      "allowfullscreen": ""
    }
  })]), _vm._v(" "), _c('p', [_c('iframe', {
    attrs: {
      "id": "spotify-frame",
      "height": "306",
      "src": "https://open.spotify.com/embed/album/7nDzwHdSE9tmlPOsIHJWg7",
      "frameborder": "0",
      "allowtransparency": "true"
    }
  })]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "//johannmiller.bandcamp.com"
    }
  }, [_vm._v("bandcamp")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "//soundcloud.com/johannmiller"
    }
  }, [_vm._v("soundcloud")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d625d40"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/MusicPage.vue
// module id = 30
// module chunks = 0